import { createSelector } from 'reselect'

export const isPostPurchaseAncillaryCartMode = (cartMode: App.CheckoutCartState['mode'] | undefined) => {
  return cartMode === 'deposit-balance'
    || cartMode === 'instalment-balance'
    || cartMode === 'instalment'
    || cartMode === 'reserve-balance'
    || cartMode === 'payment-schedule-balance'
    || cartMode === 'group-payment-share'
}

export const isPostPurchaseAncillaryPayment = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (cartMode) => isPostPurchaseAncillaryCartMode(cartMode),
)
